import React, { useState, useContext, useEffect } from "react";
import { ThemeContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";

import { useHistory } from "react-router-dom";

import theme from "../../index.scss";
import LoadingSpinner from "../UIComponents/LoadingSpinner";

import { checkNewReferral } from "../../api/referralRequest";

const OnOffButtonReferralRecord = () => {
  const { dark } = useContext(ThemeContext);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [newReferral, setNewReferral] = useState(false);
  const history = useHistory();

  useEffect(() => {
    setLoading(true);
    let isComponentMounted = true;

    const checkForNewReferral = async () => {
      try {
        const response = await checkNewReferral();
        if (isComponentMounted) {
          setNewReferral(response.data.hasNewReferral === true);
          setLoading(false);
        }
      } catch (error) {
        if (isComponentMounted) {
          console.error("Error checking for new referral:", error);
          setLoading(false);
        }
      }
    };

    checkForNewReferral();

    return () => {
      isComponentMounted = false;
    };
  }, []);

  const onClick = () => {
    setLoading(true);
    history.push("./PatientReferralRecord");
  };
  return (
    <div className="d-flex justify-content-center pt-2 pb-2 pl-1 pr-1">
      <h6
        className="pt-2 pb-2 pl-3 pr-3"
        style={{
          width: "100%",
          height: "100%",
          borderRadius: "20px",
          backgroundColor: dark
            ? theme.darkModePrimary
            : newReferral
              ? "#3EB1A6"
              : "#ef5866",
          color: dark ? theme.darkModeText : "white",
          textAlign: "center",
          overflowWrap: "break-word",
          cursor: "pointer",
        }}
        onClick={() => onClick()}
      >
        {newReferral ? (
          <div>
            {loading ? <LoadingSpinner /> : t("referralrecordbutton.new_referred")}
          </div>
        ) : (
          <div>
            {loading ? <LoadingSpinner /> : t("referralrecordbutton.check_referred")}
          </div>
        )}
      </h6>
    </div>
  );
};

export default OnOffButtonReferralRecord;